import React from "react";
import { Box, Typography, Button, Tooltip } from "@mui/material";

import { SLATE } from "../constants/Colors";

export default function AgentCard({ logoSrc, name, isLive, agentMode, onView, onBuild, onConfigure }) {
  return (
    <Box
      sx={{
        border: "1px solid rgba(0,0,0,0.07)",
        borderRadius: "16px",
        overflow: "hidden",
        bgcolor: "#ffffff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 0.2s ease",
        "&:hover": { boxShadow: "0 8px 24px rgba(0,0,0,0.1)" },
      }}
    >
      {/* Logo area */}
      <Box
        sx={{
          position: "relative",
          p: "16px",
          minHeight: 90,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          bgcolor: "#ffffff",
        }}
      >
        <img
          src={logoSrc}
          alt=""
          style={{ maxWidth: "100%", maxHeight: 72, objectFit: "contain", display: "block" }}
        />
        {isLive && (
          <Box
            sx={{
              position: "absolute",
              top: "10px",
              right: "12px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#22c55e" }} />
            <Typography sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#22c55e" }}>
              Live
            </Typography>
          </Box>
        )}
      </Box>

      {/* Name */}
      <Box sx={{ px: "16px", pt: "10px", pb: "10px", flex: 1 }}>
        <Typography
          sx={{
            fontSize: "0.9375rem",
            fontWeight: 600,
            color: SLATE[900],
            lineHeight: 1.35,
          }}
        >
          {name}
        </Typography>
      </Box>

      {/* Action buttons */}
      <Box sx={{ px: "16px", pb: "16px", pt: "4px", display: "flex", flexDirection: "row", gap: "8px" }}>
        {onView && (
          <Button
            size="small"
            variant="outlined"
            onClick={onView}
            fullWidth
            sx={{
              fontSize: "0.75rem",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: "8px",
              borderColor: "rgba(0,0,0,0.12)",
              color: "#6e6e73",
              py: "6px",
              "&:hover": {
                bgcolor: "rgba(0,113,227,0.08)",
                borderColor: "rgba(0,113,227,0.2)",
                color: "#0071e3",
              },
            }}
          >
            View
          </Button>
        )}
        {agentMode === 'agent' && onBuild && (
          <Tooltip title="✨ Configure with AI" placement="top" arrow>
            <Box
              onClick={onBuild}
              sx={{
                flex: 1, minWidth: 0,
                borderRadius: '8px',
                bgcolor: '#fff',
                border: `1px solid ${SLATE[200]}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                cursor: 'pointer',
                px: '10px',
                py: '7px',
                overflow: 'hidden',
                transition: 'background 0.15s',
                '&:hover': { bgcolor: SLATE[50] },
              }}
            >
              <Typography sx={{ fontSize: '0.75rem', lineHeight: 1, flexShrink: 0 }}>✨</Typography>
              <Typography noWrap sx={{ fontSize: '0.7rem', fontWeight: 600, color: SLATE[800], lineHeight: 1 }}>
                Configure with AI
              </Typography>
            </Box>
          </Tooltip>
        )}
        <Tooltip title="⚙️ Configure Manually" placement="top" arrow>
          <Box
            onClick={onConfigure}
            sx={{
              flex: 1, minWidth: 0,
              borderRadius: '8px',
              bgcolor: '#fff',
              border: `1px solid ${SLATE[200]}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              cursor: 'pointer',
              px: '10px',
              py: '7px',
              overflow: 'hidden',
              transition: 'background 0.15s',
              '&:hover': { bgcolor: SLATE[50] },
            }}
          >
            <Typography sx={{ fontSize: '0.75rem', lineHeight: 1, flexShrink: 0 }}>⚙️</Typography>
            <Typography noWrap sx={{ fontSize: '0.7rem', fontWeight: 600, color: SLATE[800], lineHeight: 1 }}>
              Configure Manually
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
}
